<template>
	<div class="etablissement">
		<div class="icon-wrapper">
			<div class="back" @click="$emit('home')">
				<back-icon/>
			</div>

			<div class="close" @click="close()">
				<close-icon/>
			</div>

			<div class="more" @click="fullOpen()">
				<angle-up-icon/>
			</div>
		</div>

		<section v-if="etablissement.slug">
			<header>
				<div class="title2">
					{{ etablissement.nom }}
				</div>

				<small>
					{{ etablissement.adresse }} {{ etablissement.cp }} {{ etablissement.ville }}
				</small>

			</header>

			<div class="content">
				<h4 class="state" :class="['state-' + pollutionLevel]">
					{{ pollutionStates[pollutionLevel] }}
				</h4>

				<div class="more-info">
					<p>
						Un niveau de pollution au dioxyde d’azote (NO<sub>2</sub>) de <span :class="'pollution-value state-'+pollutionLevel">{{ pollutionValue }}&nbsp;µg/m<sup>3</sup></span> est constaté dans un rayon de 50&nbsp;mètres autour de l'établissement.
					</p>


					<template v-if="moreRisk">

						<h4 class="state state-4">
							<div class="warning"><warning-icon/></div> Zone polluée à proximité (200&nbsp;m)
						</h4>


						<p>
							Cet établissement se trouve à moins de 200&nbsp;mètres d’une zone extrêmement polluée (NO<sub>2</sub>), où la norme de 40&nbsp;µg/m<sup>3</sup> est dépassée.
						</p>
					</template>



					<p class="norme">
						Norme européenne (NO<sub>2</sub>)&nbsp;: 40&nbsp;µg/m<sup>3</sup> (il s’agit de la valeur annuelle à ne pas dépasser pour limiter les effets nocifs sur la santé. Mais même en-deçà, l’absence de risque sanitaire n’est pas garantie).
					</p>




				</div>

				<cta-control class="cta-control"/>

				<div class="more-info">

					<Share :url="shareUrl"/>
				</div>

			</div>


		</section>


	</div>
</template>

<script>

import CloseIcon from './icons/croix-fermer.svg';
import WarningIcon from './icons/warning.svg';
import AngleUpIcon from './icons/fleche-haut-deplier.svg';
import CtaControl from './CtaControl.vue';
import Share from './Share.vue';
import BackIcon from './icons/angle-left.svg';

export default {
	name: 'EtablissementControl',
	components: {
		CloseIcon,
		AngleUpIcon,
		WarningIcon,
		CtaControl,
		Share,
		BackIcon,
	},
	data() {
		return {
			etablissement: {},
			pollutionStates: [
				'',
				'C’est bien !',
				'Qualité de l’air moyenne',
				'Qualité de l’air mauvaise',
				'Inacceptable et illégal !',
			]
		};
	},
	created() {
		this.$store.watch(
			(state) => this.$store.getters.etablissement,
			(e) => {

				if (e.slug) {
					this.etablissement = e
				}
				else {
					this.etablissement = {}
				}
			}
		);
	},
	methods: {
		fullOpen() {
			this.$emit('full')
		},
		close() {
			this.$emit('close')
		},
		halfOpen() {
			this.$emit('half')
		}
	},
	computed: {
		shareUrl() {
			return process.env.BASE_URL + this.etablissement.slug;
		},
		pollutionValue() {
			let v = this.etablissement.n50;
			return Math.floor(v * 100) / 100;
		},
		moreRisk() {
			return this.pollutionLevel < 4 && this.etablissement.n200
		},
		pollutionLevel() {
			let p = this.etablissement.n50;

			if (p) {
				if (p <= 10) return 1;
				if (p <= 30) return 2;
				if (p <= 40) return 3;
				return 4;
			}
		},
	},


}
</script>


<style scoped lang="scss">

.etablissement {
	@include base-box() {
		background-color: $bg-box;
		color: #fff;
		pointer-events: all;
	}

	* {
		pointer-events: all;
	}
}

section {
	pointer-events: all;
	width: 100%;
	margin: 0 auto; // 7rem;
	padding: 1rem;
	max-width: 324px;

	@include from(324px) {
		padding-left: 0;
		padding-right: 0;
	}

	@include from($tablet) {

		max-width: 400px;
	}

	@include from($desktop) {
		max-width: 500px;
	}
}

.content {

	font-family: "Roboto", sans-serif;
	font-weight: 300;
	font-size: 16px;
	line-height: 1.2;
	color: #fff;

	.more-info {
		max-height: 0;
		transition: max-height .2s;
		font-size: 1rem;
		overflow: hidden;

		.etablissement-full & {
			max-height: 100vh;
			transition: max-height 1s;
		}
	}


	.norme {
		font-size: .8em;
		color: #b4b4b4;
		margin-bottom: 1rem;
	}

	b,
	strong {
		font-weight: 700;
		color: #fff;
	}

	a {
		color: #b4b4b4 !important;
	}

	p {
		margin-bottom: 1em;
	}
}


.warning {
	vertical-align: middle;
	display: inline-flex;
	height: 1em;
	width: 1em;
	flex-direction: column;
	align-self: flex-end;

	> * {
		transform: scale(1.8);
		transform-origin: 0 0;
	}
}

.pollution-value {
font-weight: bold;
}

.icon-wrapper {
	display: flex;
	justify-content: space-between;
	margin-bottom: -1rem;

	@include from(445px) {
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
	}
}


.back,
.more,
.close {
	width: 3rem;
	height: 3rem;
	display: none;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	border-bottom-left-radius: 50%;
	background-color: $bg-box;

	* {
		fill: #fff;
		transform-origin: center;
	}
}

.back {
	display: flex;

	> * {
		width: .7rem;
		transform: scale(1.8);
	}

}

.more {
	.etablissement-open & {
		display: flex;
	}

	> * {
		transform: scale(.4);
	}

}

.close {
	.etablissement-full & {
		display: flex;
	}
	> * {
		transform: scale(.4);
	}
}

header {

	margin-right: 2rem;
	margin-bottom: 0;

	.full-open & {
		margin-bottom: 1rem;
	}

	.title2 {
		//font-family: "Archivo", sans-serif;
		font-weight: 700;
		color: #fff;
		font-size:20 px;
		line-height: 1.2;
		margin-bottom: .25em;
	}

	small {
		font-family: "Roboto", sans-serif;
		font-weight: 400;
		font-size: 14px;
		line-height: 1.2;

		display: none;
		padding-bottom: 1em;
		.etablissement-full & {
			display: block;
		}
	}
}

.state {
//	text-transform: uppercase;
	font-size: 1.7em;
	font-weight: 700;
	line-height: 1;
	margin-bottom: .8rem;
}

@for $i from 1 through length($levels) {
	$level: nth($levels, $i);

	&.state-#{$i} {
		text-shadow: 0px 0px 1px #000;
		color: $level;
		svg {
			fill: $level;
		}
	}
}


.cta-control {

	.etablissement-full & {
		margin-bottom: 1rem;
	}
}

</style>
